import type { SDSProvidedImageProps } from '@repo/sds/providers/SDSProvider/types';

/**
 * Default image component that renders a standard HTML img element.
 * Ignores Next.js specific props (fill, quality, priority, etc.) since it's just a basic img tag.
 */
export function DefaultImage({
  src,
  alt,
  className,
  dataTestId,
  onLoad,
  onError,
  style,
  width,
  height,
  loading,
  // Next.js specific props are ignored in the default implementation
  fill: _fill,
  quality: _quality,
  sizes: _sizes,
  priority: _priority,
  unoptimized: _unoptimized,
}: SDSProvidedImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      data-testid={dataTestId}
      onLoad={onLoad}
      onError={onError}
      style={style}
      loading={loading}
      width={width}
      height={height}
    />
  );
}
